import { useState, useEffect, useRef } from 'react'
import { useParams, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import Hero from '../components/Hero';
import MarginTitleGrid from '../components/MarginTitleGrid';
import RenderComponent from '../components/renderComponent';
import Close from '../assets/Close.jsx';
import Logo from '../assets/Logo.jsx';
import ReactDOM from "react-dom"
import VideoControlsEl from '../components/common/VideoControls.jsx';
import { videoControls } from '../utilities/videoControls.js';

function CaseStudyPage({lang}) {

    const navigate = useNavigate();

    const [searchParams] = useSearchParams();
    const preview = searchParams.get('preview');

    const { slug } = useParams();
    const location = useLocation();
    const [meta, setMeta] = useState({ title: '', description: '' });

    const [pageData, setPageData] = useState(null);
    const [moreProjects, setMoreProjects] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [title, setTitle] = useState(null)

    useEffect(() => {
        if (lang === "en-US") {
            setTitle("ABOUT THE PROJECT");
        } else {
            setTitle("프로젝트 소개");
        }

        const fetchPage = async () => {
            setLoading(true); // Ensure loading starts here
            setError(null);   // Clear any existing errors

            try {
                const [projectRes, allProjectsRes] = await Promise.all([
                    fetch("/api/get-content", {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            "Lang": lang,
                            "Slug": slug,
                            "Preview": preview,
                            "ContentType": "itemProject"
                        },
                    }),
                    fetch("/api/get-more-projects", {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            "Lang": lang,
                            "Slug": "vfx-all",
                            "ContentType": "pageVfx"
                        },
                    }),
                ]);

                const [projectData, allProjectsData] = await Promise.all([
                    projectRes.json(),
                    allProjectsRes.json()
                ]);

                setPageData(projectData.data || null);
                setMoreProjects(allProjectsData.data || null);

                document.title = projectData.data.title + " | Eyeline";

                let descTag = document.querySelector('meta[name="description"]');

                if (!descTag) {
                    descTag = document.createElement('meta');
                    descTag.setAttribute('name', 'description');
                    document.head.appendChild(descTag);
                }

                if (projectData.data.headline) {
                    descTag.setAttribute('content', projectData.data.headline);
                } else {
                    descTag.setAttribute('content', projectData.data.title + " | Eyeline");
                }

            } catch (err) {
                navigate('/not-found', { replace: true });
            } finally {
                setLoading(false);
            }
        };

        fetchPage();

    }, [lang, slug]);

    let heroMedia, aboutProjectItems, moreProjectItems;

    if (pageData) {

        heroMedia = pageData?.heroMedia ? pageData.heroMedia : pageData.gridImage;
        aboutProjectItems = [{
            fields: {
                title: pageData.headline,
                gridSize: "large",
                textContent: pageData.introText,
            }
        }]

        const allProjects = moreProjects.pageSections[0].fields.items;
        const currentIndex = allProjects.findIndex(p => p.fields.slug === slug);
        const total = allProjects.length;

        const nextProjects = [
            allProjects[(currentIndex + 1) % total],
            allProjects[(currentIndex + 2) % total],
        ];

        moreProjectItems = [{
            fields: {
                title: null,
                gridSize: "regular",
                moreProjects: nextProjects,
            },
            sys: {
                id: 'more_' + slug,
            }
        }]

    }

    if (pageData)

    return (
        <>
            <Hero heroSize="3/4 Screen" heroMedia={heroMedia} ctaText={lang === "ko" ? "영상 보기" : "Play Video"} ctaLink="" ctaHdVideoLink={pageData.fullVideoHdLink} ctaSdVideoLink={pageData.fullVideoSdLink} ctaVideoTitle={pageData.title} ctaTextColor="#017863" ctaShape="Play Icon" ctaBackgroundColor="#E0FEDE" />
            <section>
                 <MarginTitleGrid title={title} items={aboutProjectItems} projectIntro={true} />
            </section>
            <RenderComponent sections={pageData?.caseStudyBlocks} />
            <section>
                 <MarginTitleGrid title={lang === "ko" ? "다른 프로젝트 보기" : "EXPLORE MORE PROJECTS"} items={moreProjectItems} />
            </section>
        </>
    )

}

export default CaseStudyPage

